import { useEffect } from 'react'
import { useCallback } from 'react'
import { useState } from 'react'

import { ChainId } from '@src/configs/chainInfo'
import { GasFeeMetrics } from '@src/types/gasFees'
import { getTronEnergyPrice } from '@src/utils/tron/utils'

export const getTronGasFeeMetrics = async (gasFeeBufferBips: bigint = BigInt(11000)) => {
    const tronFees = await getTronEnergyPrice()
    if (tronFees.energyPrice && tronFees.bandwidthPrice) {
        return {
            chainId: ChainId.Tron,
            currentGasPrice: BigInt(0),
            isEIP1559: false,
            isTron: true,
            TronParams: {
                energyPrice: (BigInt(tronFees.energyPrice) * gasFeeBufferBips) / BigInt(10000),
                bandwidthPrice: BigInt(tronFees.bandwidthPrice), // Is negligible compared to energy fee
            },
            isSolana: false,
        }
    } else {
        throw new Error(`Tron energy price is undefined.`)
    }
}

export const useGasFeeMetricsTron = (chainId: number, gasFeeBufferBips: bigint) => {
    const [gasFeeMetrics, setGasMetrics] = useState<GasFeeMetrics | null>(null)
    const [error, setError] = useState<string | null>(null)
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const fetchTronGasMetrics = useCallback(async () => {
        setIsLoading(true)
        try {
            const metrics = await getTronGasFeeMetrics(gasFeeBufferBips)
            setGasMetrics(metrics)
        } catch (err) {
            setError(`Error fetching Tron gas metrics: ${(err as Error).message}`)
        } finally {
            setIsLoading(false)
        }
    }, [gasFeeBufferBips])

    useEffect(() => {
        fetchTronGasMetrics()
    }, [fetchTronGasMetrics])

    return { gasFeeMetrics, error, isLoading }
}
